<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	export let index: number;
	export let text: string;
	export let active: boolean;

	const dispatcher = createEventDispatcher<{ selectedIndex: number }>();

	function handleTabClick() {
		dispatcher('selectedIndex', index);
	}
</script>

<div
	tabindex="0"
	role="tab"
	class="flex item"
	class:selected={active}
	on:click={handleTabClick}
	on:keypress
>
	{text}
</div>

<style>
	.item {
		display: flex;
		padding: 11px 16px 12px 16px;
		justify-content: center;
		align-items: center;
		flex: 1 0 0;

		color: var(--gray-50, #a7a7a7);
		text-align: center;

		/* body-B-06 */
		font-size: 18px;
		font-family: Lato;
		font-style: normal;
		font-weight: 700;
	}
	.selected {
		border-radius: 8px;
		background: var(--p-60, #49b4b1);
		box-shadow: 0px 0px 16px 0px rgba(189, 243, 241, 0.6) inset;

		color: var(--white, #fff);
	}
</style>
